/* eslint-disable no-magic-numbers */
export enum LogActionEnum {
  Created = 'Created',
  Edited = 'Edited',
  Renewed = 'Renewed',
  Deleted = 'Deleted',
  Restored = 'Restored',
}

export const LogActionLabels = {
  [LogActionEnum.Created]: 'created',
  [LogActionEnum.Edited]: 'edited',
  [LogActionEnum.Renewed]: 'renewed',
  [LogActionEnum.Deleted]: 'deleted',
  [LogActionEnum.Restored]: 'restored',
};

export const LogActionLabelDescription = {
  [LogActionEnum.Created]: 'objectHasBeenCreated',
  [LogActionEnum.Edited]: 'objectHasBeenEdited',
  [LogActionEnum.Renewed]: 'objectHasBeenRenewed',
  [LogActionEnum.Deleted]: 'objectHasBeenDeleted',
  [LogActionEnum.Restored]: 'objectHasBeenRestored',
};
